<div class="notification-container">
  <ngb-toast
    *ngFor="let notification of notifications"
    [ngClass]="className(notification)"
    [autohide]="true"
    [delay]="notification.timeout || 5000"
    (hide)="close(notification)">
    {{notification.message}}
  </ngb-toast>
</div>
